import { render, staticRenderFns } from "./IssueStatus.vue?vue&type=template&id=5957432f&"
import script from "./IssueStatus.vue?vue&type=script&lang=ts&"
export * from "./IssueStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports